/*import React, { useState } from "react";
import "./question.css";
import faqBg from "../../../assets/faq-image.jpeg";

const faqs = [
  {
    question: "1. What services does Cybredge provide?",
    answer: (
      <>
        We offer IT services including Web & App Development, Cloud Computing,
        Cyber Security, AI Automation Solutions, and Server/Data Center
        architecture.
      </>
    ),
  },
  {
    question: "2. Can I customize my service package?",
    answer: (
      <>
        Yes, we provide fully flexible service plans based on your business
        requirements.
      </>
    ),
  },
  {
    question: "3. Do you offer 24/7 technical support?",
    answer: (
      <>
        Yes, our Standard & Premium plans include dedicated 24×7 support
        availability.
      </>
    ),
  },
  {
    question: "4. How do I request a custom quote or proposal?",
    answer: (
      <>
        You can request a quote using the Request Custom Quote button or via
        email.
      </>
    ),
  },
  {
    question: "5. Do you provide cybersecurity & data protection services?",
    answer: (
      <>
        Absolutely — we offer network firewalls, penetration testing,
        encryption, monitoring, and SOC solutions.
      </>
    ),
  },
  {
    question: "7. What makes Cybredge different from other IT companies?",
    answer: (
      <>
        Transparent pricing, advanced technology, fast delivery,
        enterprise-level security, and dedicated expert team.
      </>
    ),
  },
  {
    question: "Still Need Help?",
    answer: (
      <>
        📩 Email: cyber.edge@yandex.com <br />
        📞 Support: Available 24×7
      </>
    ),
  },
];

const FAQAccordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section
      className="faq-section"
      style={{
        backgroundImage: `url(${faqBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="faq-box">
        <h2 className="title">Frequently Asked Questions(FAQ)</h2>
        <div className="underline" />

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              className={`item ${activeIndex === index ? "active" : ""}`}
              key={index}
            >
              <button
                type="button"
                className="question"
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                <span className="arrow">
                  {activeIndex === index ? "▲" : "▼"}
                </span>
              </button>

              {activeIndex === index && (
                <div className="answer">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQAccordion;*/

import React, { useState } from "react";
import faqBg from "../../../assets/faq-image.jpeg";

const faqs = [
  {
    question: "1. What services does Cybredge provide?",
    answer: (
      <>
        We offer IT services including Web & App Development, Cloud Computing,
        Cyber Security, AI Automation Solutions, and Server/Data Center
        architecture.
      </>
    ),
  },
  {
    question: "2. Can I customize my service package?",
    answer: (
      <>
        Yes, we provide fully flexible service plans based on your business
        requirements.
      </>
    ),
  },
  {
    question: "3. Do you offer 24/7 technical support?",
    answer: (
      <>
        Yes, our Standard & Premium plans include dedicated 24×7 support
        availability.
      </>
    ),
  },
  {
    question: "4. How do I request a custom quote or proposal?",
    answer: (
      <>
        You can request a quote using the Request Custom Quote button or via
        email.
      </>
    ),
  },
  {
    question: "5. Do you provide cybersecurity & data protection services?",
    answer: (
      <>
        Absolutely — we offer network firewalls, penetration testing,
        encryption, monitoring, and SOC solutions.
      </>
    ),
  },
  {
    question: "7. What makes Cybredge different from other IT companies?",
    answer: (
      <>
        Transparent pricing, advanced technology, fast delivery,
        enterprise-level security, and dedicated expert team.
      </>
    ),
  },
  {
    question: "Still Need Help?",
    answer: (
      <>
        📩 Email: cyber.edge@yandex.com <br />
        📞 Support: Available 24×7
      </>
    ),
  },
];

const FAQAccordion = () => {
  // 👇 simple JS state (no "number" type)
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section
      className="
        relative min-h-screen
        flex items-start justify-start
        pt-16 pb-20
        pl-3 pr-3 md:pl-10 md:pr-8
      "
      style={{
        backgroundImage: `url(${faqBg})`,
        backgroundSize: "cover",

        backgroundPosition: "80% 30%",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* FAQ BOX – LEFT SIDE */}
      <div
        className="
          max-w-3xl w-full 
          bg-black/60 text-white
          rounded-2xl px-6 md:px-8 py-8 md:py-10
          shadow-[0_18px_40px_rgba(0,0,0,0.6)]
          font-sans
          ml-0
        "
      >
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-1">
          Frequently Asked Questions (FAQ)
        </h2>

        <div className="w-16 h-[3px] bg-rose-400 rounded-full mx-auto my-4" />

        <div className="mt-2">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`mb-3 rounded-xl border overflow-hidden transition-all duration-200 
                ${
                  activeIndex === index
                    ? "border-violet-500 bg-slate-900/90"
                    : "border-slate-400/40 bg-slate-900/80"
                }`}
            >
              <button
                type="button"
                onClick={() => toggleFAQ(index)}
                className="
                  w-full flex items-center justify-between
                  px-4 md:px-5 py-3.5
                  text-left text-sm md:text-base font-semibold
                  text-slate-100 cursor-pointer
                  hover:bg-slate-900/70
                "
              >
                <span>{faq.question}</span>
                <span className="text-indigo-300">
                  {activeIndex === index ? "▲" : "▼"}
                </span>
              </button>

              {activeIndex === index && (
                <div className="px-4 md:px-5 pb-4 text-sm leading-relaxed text-white">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQAccordion;
